import { render } from "./UserDialog.vue?vue&type=template&id=3247efe0&ts=true"
import script from "./UserDialog.ts?vue&type=script&lang=ts"
export * from "./UserDialog.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__